export default __webpack_public_path__ + "static/media/landscape15.e4f374b2.jpg";